import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import RoundEnquiryGateModal from "../../../components/RoundEnquiryGateModal";
import { API_BASE_URL } from "../../../config";
import {
  FaMapMarkerAlt,
  FaDollarSign,
  FaUsers,
  FaTruck,
  FaTools,
  FaBriefcase,
} from "react-icons/fa";



export default function PoolCareBusinessFranchiseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showGate, setShowGate] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchListing();
    // eslint-disable-next-line
  }, [id]);

  const fetchListing = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/poolcare/business-franchise/${id}`
      );

      if (res.data?.success && res.data.listing) {
        setListing(res.data.listing);
      }
    } catch (err) {
      console.error("❌ Failed to load pool care listing:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: 40 }}>Loading listing…</div>;
  }

  if (!listing) {
    return <div style={{ padding: 40 }}>Listing not found.</div>;
  }

  return (
    <div style={{ background: "#f5f7f9", minHeight: "100vh" }}>
      <div style={{ maxWidth: 900, margin: "40px auto" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            overflow: "hidden",
            boxShadow: "0 6px 16px rgba(0,0,0,.12)",
          }}
        >
          <img
            src="/images/poolcare.jpg"
            alt="Pool Care Business"
            style={{ width: "100%", height: 280, objectFit: "cover" }}
          />

          <div style={{ padding: 30 }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "transparent",
                border: "none",
                color: "#2e7d32",
                fontWeight: "bold",
                cursor: "pointer",
                marginBottom: 15,
              }}
            >
              ← Back to listings
            </button>

            <h2 style={{ color: "#2e7d32" }}>
              {listing.business_title || "Pool Care Business"}
            </h2>

          <p style={{ color: "#666" }}>
  Listing ID: PCB-{listing.id}
</p>

<p style={{ color: "#888", fontSize: "0.9rem", marginTop: "3px" }}>
  📅 Posted:{" "}
  {listing.created_at
    ? new Date(listing.created_at).toLocaleDateString()
    : "—"}
</p>

            <p>
              <FaMapMarkerAlt /> {listing.suburb}, {listing.state}{" "}
              {listing.postcode}
            </p>

            <h3 style={{ marginTop: 20 }}>
              Asking Price: $
              {Number(listing.price).toLocaleString()}
            </h3>

           {/* OVERVIEW */}
{listing.listing_type === "business" ? (
  <>
    <h3 style={{ marginTop: 30, color: "#2e7d32" }}>
      Business Overview
    </h3>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 15,
      }}
    >
      <div>
        <FaDollarSign /> Yearly Revenue: $
        {Number(listing.yearly_revenue || 0).toLocaleString()}
      </div>

      <div>
        <FaUsers /> Clients: {listing.clients_count || 0}
      </div>

      <div>
        <FaDollarSign /> Total Client Value: $
        {Number(listing.total_client_value || 0).toLocaleString()}
      </div>

      <div>
        <FaBriefcase /> Type: Business
      </div>
    </div>
  </>
) : (
  <>
    <h3 style={{ marginTop: 30, color: "#2e7d32" }}>
      Business Overview
    </h3>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 15,
      }}
    >
      <div>
        <FaBriefcase /> Business Brand: {listing.franchise_brand || "—"}
      </div>

      <div>
        <FaUsers /> Clients: {listing.number_of_clients || 0}
      </div>

      <div>
        <FaDollarSign /> Avg Job Price: $
        {Number(listing.avg_job_price || 0).toLocaleString()}
      </div>

      <div>
        <FaMapMarkerAlt /> Service Area: {listing.territory_name || "—"}
      </div>
    </div>
  </>
)}


            {listing.business_description && (
              <>
                <h3 style={{ marginTop: 25, color: "#2e7d32" }}>
                  Description
                </h3>
                <p>{listing.business_description}</p>
              </>
            )}

            {/* INCLUDED ITEMS */}
            <h3 style={{ marginTop: 25, color: "#2e7d32" }}>
              Included Items
            </h3>

            <p>
              <FaTruck /> Vehicle Included:{" "}
              {listing.vehicle_included ? "Yes" : "No"}
            </p>
            {listing.vehicle_details && <p>{listing.vehicle_details}</p>}

            <p>
              <FaTools /> Equipment Included:{" "}
              {listing.equipment_included ? "Yes" : "No"}
            </p>
            {listing.equipment_details && (
              <p>{listing.equipment_details}</p>
            )}

            {/* CONTACT SELLER */}
            <button
              style={{
                width: "100%",
                marginTop: 30,
                padding: 14,
                background: "#2e7d32",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                fontSize: "1.1rem",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user.id === listing.user_id) {
                  alert("You cannot enquire on your own listing.");
                  return;
                }
                setShowGate(true);
              }}
            >
              Contact Seller
            </button>
          </div>
        </div>
      </div>

      {/* ENQUIRY MODAL */}
      {showEnquiry && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 25,
              borderRadius: 10,
              width: "90%",
              maxWidth: 500,
            }}
          >
            <h2 style={{ color: "#2e7d32" }}>Contact Seller</h2>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                const token = localStorage.getItem("token");

                try {
                  const res = await axios.post(
                    `${API_BASE_URL}/api/contact-seller`,
                    {
                      listing_id: listing.id,
                      listing_type: "poolcare_business",
                      message: e.target.message.value,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  if (res.data.success) {
                    alert("Enquiry sent successfully.");
                    setShowEnquiry(false);
                  } else {
                    alert("Failed to send enquiry.");
                  }
                } catch {
                  alert("Server error sending enquiry.");
                }
              }}
            >
              <textarea
                name="message"
                rows="4"
                required
                placeholder="Write your message to the seller..."
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  marginBottom: 15,
                }}
              />

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: 12,
                  background: "#2e7d32",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  fontWeight: "bold",
                }}
              >
                Send Enquiry
              </button>

              <button
                type="button"
                onClick={() => setShowEnquiry(false)}
                style={{
                  width: "100%",
                  padding: 10,
                  marginTop: 10,
                  background: "#ccc",
                  border: "none",
                  borderRadius: 6,
                }}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* GATE MODAL */}
      <RoundEnquiryGateModal
        isOpen={showGate}
        onClose={() => setShowGate(false)}
        onContinue={() => {
          setShowGate(false);
          setShowEnquiry(true);
        }}
      />
    </div>
  );
}
